export const selectTemplateName = ({fabricTemplate}) => fabricTemplate.templateName;
export const selectFabricTemplateUsedAs = ({fabricTemplate}) =>
  fabricTemplate.usedAs || fabricTemplate.used_as || window.fabricTemplate?.used_as;
